module.exports = __webpack_public_path__ + "img/content-1.383bc5ac.png";